import React from 'react';

const ChevronRight = ({ fill = "#D5D7DA", width = "16", height = "16" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none">
      <path d="M6 12L10 8L6 4" stroke={fill} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default ChevronRight;
